import { ReportFeatures } from '@hcs/types';

export const USER_OPINION_OF_PRICE_FORM_FEATURES_SALE: ReportFeatures[] = [
  ReportFeatures.UserOpinionOfPrice,
];

export const USER_OPINION_OF_PRICE_FORM_FEATURES_RENTAL: ReportFeatures[] = [
  ReportFeatures.RentalUserOpinionOfPrice,
];
